module.exports = __webpack_public_path__ + "static/media/messangerIcon.b1f3859d.svg";